import { Fragment } from "react";

import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { MedicalItem } from "@/Patient/Models/MedicalSummary/MedicalItem";
import { MedicalItemProblemAndCondition } from "@/Patient/Models/MedicalSummary/MedicalItemProblemAndCondition";

interface IProblemItemsProps {
    title: string;
    problems: MedicalItemProblemAndCondition[];
    onMedicalItemClick: (item: MedicalItem, view: MedicalItemsTab, fromAssessment: boolean) => void;
}

function ProblemItems(props: IProblemItemsProps): JSX.Element {
    const result = props.problems.map(problem => {
        const invalidStyle = problem.DisplayAsInvalid ? "invalid-medical-item" : "";

        if (!isArrayNullOrUndefinedOrEmpty(problem.QualifiedDetails)) {
            return (
                <Fragment
                    key={"problem-items-" + problem.Id}
                >
                    <tr
                        className={"medical-note-item " + invalidStyle}
                        onClick={() => props.onMedicalItemClick(problem, MedicalItemsTab.MedicalProblem, false)}
                    >
                        <td className="c1">
                            <div className="tb-row tb">
                                <strong>
                                    <span className={invalidStyle}>
                                        {PatientMedicalSummaryHelper.GetLifeStageString(problem)}
                                    </span>
                                </strong>
                            </div>
                        </td>
                        <td className="c2">
                            {problem.QualifiedDetails.map(qd => (
                                <div className="tb-row tb" key={qd.Id}>
                                    <div className="add-btn-column" />
                                    <div className="flex-container">
                                        <div>
                                            <a>
                                                {settingsStore.configuration.get("ShowDiagnosisCode") &&
                                                    <span>{qd.Code} -</span>
                                                }
                                                <span className={invalidStyle}>{qd.Text} </span>
                                            </a>
                                        </div>
                                        <div className="margin-sm-left">
                                            <a> {qd.StatusLookupId != null ? `(${cacheStore.GetLocalizedValueByLookupId(qd.StatusLookupId)})` : ""}  </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {!IsNullOrWhiteSpace(problem.ProblemDescription) && (
                                <div className="tb-row tb">
                                    <div className="add-btn-column" />
                                    <strong className="text-italic">
                                        <span className={invalidStyle}>
                                            {JSXHelper.BreakStringIntoParagraphs(problem.ProblemDescription, true)}
                                        </span>
                                    </strong>
                                </div>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td><span>&nbsp;</span></td>
                    </tr>
                </Fragment>
            );
        }
    });

    return (
        <>
            <tr>
                <td className="c1">
                    <strong className="underline">{props.title}</strong>
                </td>
                <td className="c2" />
                <td className="c3" />
            </tr>
            {result}
        </>
    );
}

export { ProblemItems };
